import React, { useState, useCallback, useEffect } from "react";
import search from "../../Images/search.png";
import CloseImg from "../../Images/CloseImg.png";
import upperRightArrowImage from "../../Images/upperRightArrowImage.png";

import DrawerMenuImage from "../../Images/DrawerMenuImage.png";
import star from "../../Images/star.png";

import debounce from "lodash.debounce";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Categories from "../MainPageComponents.js/Categories";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "90%",
    //   window.innerWidth <= 1440
    //     ? "50%"
    //     : window.innerWidth <= 1920
    //     ? "30%"
    //     : window.innerWidth <= 2560
    //     ? "50%"
    //     : window.innerWidth <= 3840
    //     ? "60%"
    //     : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function SearchSection() {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);

  const [loading, setLoading] = useState(false);

  // Function to fetch products based on search term
  const fetchProducts = async (query) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${MyDomain}Products/GetProductsUsingSearch?search=${query}`
      );
      console.log(response.data);
      setProducts(response.data.products || []); // Ensure it's always an array
      setBrands(response.data.brands || []);
    } catch (err) {
      console.log(err.response.data);
      setProducts([]); // Reset products on error
    } finally {
      setLoading(false);
    }
  };

  // Debounce the API call to avoid too many requests while typing
  const debouncedFetchProducts = useCallback(debounce(fetchProducts, 500), []);

  // Update searchTerm state
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedFetchProducts(value); // Call debounced function
  };
  const [openDone, setOpenDone] = useState(false);

  const handleClose2 = () => {
    setOpenDone(false);
  };

  const handleDivClick2 = (ProductId) => {
    handleClose2();
    history.push(`/product/${ProductId}`);
  };

  const handleDivClick3 = (BrandName) => {
    handleClose2();
    history.push(`/search/?q=${BrandName}`);
    window.location.reload(); // This will force a full page reload
  };
  function ModalDone() {
    return (
      <div>
        <BootstrapDialog
          onClose={handleClose2}
          aria-labelledby="customized-dialog-title"
          open={openDone}
          fullWidth
          maxWidth={false} // Disable Material-UI's default width settings
          PaperProps={{
            sx: {
              position: "absolute",
              top: 50, // Align to the top of the viewport
              left: "50%",
              transform: "translateX(-50%)", // Center horizontally
              margin: 0,
              height: products.length > 0 ? "calc(90vh - 55px)" : 80, // Dynamic height based on products
              display: "flex",
              flexDirection: "column", // Ensure the content is stacked vertically
            },
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start", // Align content to the top
              alignItems: "center",
              padding: "20px",
              //overflowY: "auto", // Allows scrolling if content overflows
              //flexGrow: 1, // Ensure this div grows to take available space
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                //backgroundColor: "red",
                alignItems: "center",
                height: 40,
                justifyContent: "space-between",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              <div
                style={{
                  width: "100%",
                }}
              >
                <img
                  src={search}
                  alt="logo"
                  style={{
                    minWidth: "30px", // Adjust the size
                    height: "30px", // Adjust the size
                    //borderRadius: "50%", // Makes the image circular
                    //paddingLeft: 200,
                    cursor: "pointer",
                  }}
                  onClick={() => {}}
                />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder={t("profile.morethan100000products")}
                  style={{
                    padding: "10px",
                    border: "none", // This removes the border
                    outline: "none", // This removes the outline when the input is focused (optional)
                    width: "80%",
                    fontSize: 14,
                    opacity: 0.6,
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <img
                  src={CloseImg}
                  alt="logo"
                  style={{
                    minWidth: "30px", // Adjust the size
                    height: "30px", // Adjust the size
                    //borderRadius: "50%", // Makes the image circular
                    //paddingLeft: 200,
                    cursor: "pointer",
                  }}
                  onClick={handleClose2}
                />
              </div>
            </div>

            {loading && <p>Loading...</p>}

            <div
              style={{
                width: "100%",
                paddingTop: products.length > 0 ? 20 : 0,
                //backgroundColor: "red",
                height: products.length > 0 ? "calc(75vh - 55px)" : 0, // Dynamic height based on products
              }}
            >
              {products.length > 0 ? (
                <div
                  style={{
                    height: "0.1px",
                    backgroundColor: "#f4f4f5",
                    width: "100%",
                    //marginTop: products.length > 0 ? 10 : 10,
                    marginBottom: 40,
                  }}
                ></div>
              ) : (
                <></>
              )}
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    //display: "flex",
                    //backgroundColor: "blue",
                  }}
                >
                  {brands.map((item) => (
                    <div key={item.id} style={{}} onClick={() => {}}>
                      <div
                        style={{
                          display: "flex",
                          //backgroundColor: "red",
                          justifyContent: "space-between",
                          width: "80%",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          //handleDivClick2(item.id);
                          handleDivClick3(item.name);
                        }}
                      >
                        <a>{item.name}</a>{" "}
                        <img
                          src={upperRightArrowImage}
                          alt="Sample"
                          style={{
                            //maxHeight: "200px",
                            width: 18,
                            objectFit: "cover",
                            opacity: 0.5,
                            //borderRadius: "8px",
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    width: "75%",
                    //maxHeight: "300px", // Adjust height as needed
                    overflowY: "auto", // Adds scrolling when content overflows
                    padding: 0,
                    margin: 0,
                    listStyleType: "none",
                    //backgroundColor: "orange",
                    maxHeight: products.length > 0 ? "calc(74vh - 55px)" : 0, // Dynamic height based on products
                    position: "relative",
                  }}
                >
                  <a
                    style={{
                      fontWeight: "500",
                      fontSize: 20,
                    }}
                  >
                    Products
                  </a>
                  {products.length > 0 ? (
                    <div
                      style={{
                        height: "86%",
                        //maxHeight: "300px", // Adjust height as needed
                        overflowY: "auto", // Adds scrolling when content overflows
                        padding: 0,
                        margin: 0,
                        listStyleType: "none",
                        //backgroundColor: "red",
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(250px, 1fr))",
                          gap: "20px",
                        }}
                      >
                        {products.map((item) => (
                          <div
                            key={item.id}
                            style={{
                              //border: "1px solid #ddd",
                              //padding: 16,
                              //borderRadius: 8,
                              backgroundColor: "#fff",
                              //boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              //handleDivClick(item.title, item.id);
                            }}
                          >
                            <div
                              //style={{ backgroundColor: "gray" }}
                              onClick={() => {
                                handleDivClick2(item.id);
                              }}
                            >
                              <img
                                src={item.image}
                                alt="Sample"
                                style={{
                                  //maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "cover",
                                  //borderRadius: "8px",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                paddingTop: 15,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <a style={{ fontSize: 18 }}>{item.name}</a>
                              <a style={{ fontSize: 14, opacity: 0.5 }}>
                                {item.productType}
                              </a>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingTop: 10,
                                }}
                              >
                                {[1, 2, 3, 4, 5].map((_, idx) => (
                                  <img
                                    key={idx}
                                    src={star}
                                    alt="star"
                                    style={{
                                      width: 8,
                                      height: 8,
                                      marginRight: 3,
                                      marginBottom: 10,
                                    }}
                                  />
                                ))}
                              </div>
                              <a style={{ fontSize: 15 }}>₪{item.price}</a>
                              <p
                                style={{
                                  paddingTop: 10,
                                  fontSize: 14,
                                  opacity: 0.5,
                                }}
                              >
                                {item.dateStart}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* {products.map((product) => (
                        <div key={product.Id}>
                          <a>{product.name}</a>
                        </div>
                        // <li key={product.Id}>
                        //   <strong>{product.name}</strong>: {product.brand} - $
                        //   {product.price}
                        // </li>
                      ))} */}
                    </div>
                  ) : (
                    <></>
                    // !loading && <p>No products found</p>
                  )}
                  {products.length > 0 ? (
                    <div
                      style={{
                        height: "0.1px",
                        backgroundColor: "#f4f4f5",
                        width: "100%",
                        //marginTop: products.length > 0 ? 10 : 10,
                        marginBottom: 40,
                      }}
                    ></div>
                  ) : (
                    <></>
                  )}
                  {products.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "row",
                        //backgroundColor: "yellow",
                        position: "absolute",
                        bottom: 0,
                        paddingTop: 15,
                      }}
                    >
                      <button
                        style={{
                          //marginTop: 20,
                          backgroundColor: "#27272a",
                          color: "#fff",
                          border: "none",
                          //padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "16px",
                          //width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: 50,
                          width: 250,
                        }}
                        onClick={() => {
                          //CreateCallBack();
                          handleDivClick3(searchTerm);
                        }}
                      >
                        <a style={{ fontSize: 14 }}>
                          {t("profile.AllResults")}
                        </a>
                      </button>{" "}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </BootstrapDialog>
      </div>
    );
  }
  ///////open categories drawerr
  const [openCategoriesDrawer, setOpenCategoriesDrawer] = useState(false);

  const handleOpenCloseDrawer = () => {
    setOpenCategoriesDrawer((prevState) => !prevState);
  };
  ///////end open categories drawerr

  return (
    <div>
      {ModalDone()}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {MyWidth <= 1024 ? (
          <div>
            <div
              style={{
                alignItems: "flex-end",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={DrawerMenuImage}
                style={{
                  width: 40,
                  height: 40,
                  margin: 0,
                  //marginLeft: "2%",
                  cursor: "pointer",
                  //marginRight: 10,
                  marginRight: i18n.resolvedLanguage === "en" ? 10 : 0,
                }}
                onClick={handleOpenCloseDrawer}
                //onClick={() => setOpenCategoriesDrawer(true)}
              />
              <Categories
                openCategoriesDrawer={openCategoriesDrawer}
                setOpenCategoriesDrawer={setOpenCategoriesDrawer}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
        <img
          src={search}
          alt="logo"
          style={{
            minWidth: "30px", // Adjust the size
            height: "30px", // Adjust the size
            //borderRadius: "50%", // Makes the image circular
            //paddingLeft: 200,
            cursor: "pointer",
          }}
          onClick={() => {
            setOpenDone(true);
          }}
        />
      </div>
    </div>
  );
}
